import React, { useContext, useEffect, useState } from 'react';

import _ from 'lodash';

import LegoAdminPageContext from '../../../pages/legoAdminPageContext';
import LegoContextSummary from '../LegoContextSummary';
import LegoEditButton from '../LegoEditButton';
import ImageClusterPreview from '../../images/ImageClusterPreview';

export function LinkedImageClusters({ templateId, templateContext, templateClusters }) {
  const { page } = useContext(LegoAdminPageContext);
  const [references, setReferences] = useState(null);

  useEffect(() => {
    if (!templateId) return;
    page.service('services/legos').find({
      query: {
        'data.templateId': templateId,
        $select: {
          'context': 1,
          'data.templateId': 1,
          'data.imageClusters': 1,
        },
      }
    }).then(setReferences);
  }, [templateId]);

  if (!references) {
    return <div className={'text-secondary p-3'}>Loading references...</div>;
  }

  const sourcesByCluster = {};

  _.each(templateClusters || [], c => {
    sourcesByCluster[c] = sourcesByCluster[c] || [];
    sourcesByCluster[c].push({ fromTemplate: true, context: templateContext });
  });

  _.each(references, fb => {
    _.each(fb.data, (box, i) => {
      if (box.templateId !== templateId) return;
      _.each(box.imageClusters || [], c => {
        sourcesByCluster[c] = sourcesByCluster[c] || [];
        sourcesByCluster[c].push({ fromTemplate: false, lego: fb, boxIndex: i });
      });
    });
  });

  const entries = _.toPairs(sourcesByCluster);

  if (!entries.length) {
    return <div className={'text-secondary p-3 text-center'}>No image clusters linked via this template</div>;
  }

  return <div className={'bg-light rounded p-2'} style={{ maxHeight: '85vh', overflow: 'auto' }}>
    <table className={'table table-sm align-middle'}>
      <thead>
        <tr>
          <th>Cluster</th>
          <th>Linked via</th>
        </tr>
      </thead>
      <tbody>
        {_.map(entries, ([clusterId, sources]) => (
          <tr key={clusterId} className={'border-top border-secondary'}>
            <td><ImageClusterPreview clusterId={clusterId}/></td>
            <td>
              {_.map(sources, (s, j) => (
                <div key={j} className={'mb-1 d-flex align-items-center flex-wrap'}>
                  {s.fromTemplate ? (
                    <span className={'badge badge-info mr-2'}>template</span>
                  ) : (
                    <LegoEditButton legoId={s.lego._id}
                                    editorProps={{ openedFusebox: s.boxIndex }}
                                    extraQuery={`openedFusebox=${s.boxIndex}`}
                                    lego={{ type: 'fusebox', context: s.lego.context }}>
                      <span className={'small mr-2'}>{s.lego._id}</span>
                    </LegoEditButton>
                  )}
                  <div className={'text-ellipsis'}>
                    <LegoContextSummary inline context={s.fromTemplate ? s.context : s.lego.context}/>
                    </div>
                </div>
              ))}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>;
}
